/**
 * Enum representing the different mutation types for associating payment preferences with positions during various workflows.
 * This enum controls which mutation operation is triggered based on the selected action, determining how payment preferences
 * are applied or updated across positions, accounts, and other objects.
 *
 * @purpose Controls the selection of the appropriate mutation operation for updating payment preferences in different workflows.
 */

export enum AssociatePaymentPrefMutationTypeEnum {
  /**
   * This operation is used to update all positions associated with an account from an old payment preference
   * to a new one. It replaces the specified old payment preference with the new payment preference across
   * all relevant positions for the account.
   *
   * @mutation `UpdatePaymentPrefForPositionsOfPaymentPrefMutation`
   */
  AllOtherPositionsWithPaymentPref = "allPositionWithPaymentPref",

  /**
   * This operation is used to update the payment preference of a specific position. It updates the position's
   *  payment preference to the new one provided.
   *
   * @mutation `UpdatePaymentPrefForPositionMutation`
   */
  OnlyThisPosition = "onlyThisPosition",

  /**
   * This operation is used to update all positions within an account to have the same payment preference information. It updates
   *  the payment preference information of all other positions in the account to match the provided payment preference,
   * ensuring consistency across the account's positions. Note that while the positions' payment preference
   * information is updated, the accounts themselves remain unchanged.
   *
   * @mutation `UpdatePaymentPrefForAccountsMutation`
   */
  AllOtherPositionsInAccount = "allOtherPositionsInAccount",

  /**
   * Updates positions within an account that do not have any payment preference assigned.
   *
   * @mutation unknown
   */
  PositionsWithoutPaymentPrefOfAccount = "positionsWithoutPaymentPrefOfAccount",
}
